// src/services/user.js (hoặc ./services/user/index.js)
import * as apiUrls from "../api-url";
import { AxiosClient } from "../axios-client";
const axiosClient = new AxiosClient();


const getErrMsg = (err, fallback = "Đã có lỗi xảy ra") => {
  const e = err ?? {};

  if (e.response?.data) {
    const d = e.response.data;
    if (typeof d === "string") return d;
    if (typeof d?.message === "string") return d.message;
    if (Array.isArray(d?.errors) && typeof d.errors[0]?.message === "string") {
      return d.errors[0].message;
    }
  }
  if (typeof e.message === "string") return e.message;
  if (typeof e === "string") return e;
  if (typeof e.statusText === "string") return e.statusText;
  return fallback;
};

const safe = async (fn, fallbackMsg) => {
  try {
    return await fn();
  } catch (err) {

    throw new Error(getErrMsg(err, fallbackMsg));
  }
};


export const verify = async (data) =>
  safe(() => axiosClient.post(`${apiUrls.USER_VERIFY}`, data), "Xác thực thất bại");

export const login = async (data) =>
  safe(() => axiosClient.post(`${apiUrls.USER_LOGIN}`, data), "Đăng nhập thất bại");

export const getPaging = async (params = {}) =>
  safe(async () => {
    const { pageIndex = 1, pageSize = 10, username, fullname } = params;

    const qs = new URLSearchParams();
    qs.set("pageIndex", String(pageIndex));
    qs.set("pageSize", String(pageSize));
    if (username) qs.set("username", username);
    if (fullname) qs.set("fullname", fullname);

    const url = `${apiUrls.USERS_GET_PAGING}?${qs.toString()}`;
    return await axiosClient.get(url);
  }, "Không lấy được danh sách người dùng");

export const create = async (data) =>
  safe(() => axiosClient.post(`${apiUrls.USER_CREATE}`, data), "Tạo người dùng thất bại");

export const update = async (data) =>
  safe(
    () => axiosClient.put(`${apiUrls.USER_UPDATE}/${data?._id ?? data?.id}`, data),
    "Cập nhật người dùng thất bại"
  );

export const remove = async (id) =>
  safe(() => axiosClient.delete(`${apiUrls.USER_DELETE}/${id}`), "Xóa người dùng thất bại");
